import { createFileRoute } from '@tanstack/react-router';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';
import { OrderSettingsPage } from '@/pages/settings/order-settings/OrderSettingsPage';

export const Route = createFileRoute('/_authenticated/_app/settings/order-settings')({
	beforeLoad: ({ context }) => requireAnyPermission({ context, anyOf: ['companySettings.manageOrderSettings'] }),
	component: OrderSettingsPage,
});
